import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import { Observable } from 'rxjs';
import {
    VehicleCategory,
    VehicleMake,
    VehicleModel,
} from '../models/industry-dropdowns.model';

@Injectable({
    providedIn: 'root',
})
export class IndustryDropdownsService {
    constructor(
        private configService: ConfigService,
        private http: HttpClient
    ) {}

    getVehicleCategories(): Observable<VehicleCategory> {
        const url = `${this.configService.apiUrl.etc}/api/v1/industry/dropdowns/categories`;
        return this.http.get<VehicleCategory>(url);
    }

    getVehicleMakes(categoryId: string): Observable<VehicleMake> {
        const url = `${this.configService.apiUrl.etc}/api/v1/industry/dropdowns/makes/categories/${categoryId}`;
        return this.http.get<VehicleMake>(url);
    }

    getVehicleYears(categoryId: string, makeId: string): Observable<string[]> {
        const url = `${this.configService.apiUrl.etc}/api/v1/industry/dropdowns/years/categories/${categoryId}/makes/${makeId}`;
        return this.http.get<string[]>(url);
    }

    getVehicleModels(
        categoryId: string,
        makeId: string,
        year: number
    ): Observable<VehicleModel> {
        const url = `${this.configService.apiUrl.etc}/api/v1/industry/dropdowns/models/categories/${categoryId}/makes/${makeId}/years/${year}`;
        return this.http.get<VehicleModel>(url);
    }
}
